<template>
  <codemirror ref="cm" :value="tempValue" :options="tempOptions" @input="handleInput" />
</template>

<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript'

function stringifiedJson(value, tabWidth = 0) {
  try {
    if (value === null) return ''
    return JSON.stringify(JSON.parse(value), null, tabWidth)
  } catch (e) {
    return value
  }
}

export default {
  components: {
    codemirror
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tempValue: stringifiedJson(this.value, 2),
      tempOptions: {
        mode: 'application/json',
        lineNumbers: true,
        ...this.options
      }
    }
  },
  computed: {
    instance() {
      return this.$refs.cm.codemirror
    }
  },
  methods: {
    handleInput(value) {
      this.tempValue = value
      this.$emit('input', stringifiedJson(value))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/CodeMirror.vue